import type { FinancialProduct } from '@interfaces/financialProduct';
import type { Security } from '@ovComponents/3-pattern/securitiesSelectionTable/types';

/**
 * Replaces a cash security's financialProduct with the org-level cash product
 * so the securities-table chip and IPS asset-class IDs are consistent (OVT-6062).
 */
export const normalizeCashSecurity = (
  security: Security,
  cashProduct: FinancialProduct | null | undefined,
): Security => {
  if (!cashProduct) return security;
  const isCash =
    security.financialProduct.isCash ||
    security.financialProduct.id === cashProduct.id;
  if (!isCash) return security;
  return { ...security, financialProduct: cashProduct };
};
